import { useState } from "react";
import { ProductGrid } from "@/components/ProductGrid";
import SearchInput from "@/components/search/SearchInput";
import { Product } from "@/types/product";

export default function Index() {
  const [products, setProducts] = useState<Product[]>([]);

  return (
    <main className="flex-1">
      <div className="container">
        <div className="py-8">
          <SearchInput onResultsChange={setProducts} />
          <ProductGrid products={products} />
        </div>
      </div>
    </main>
  );
}